import { CityModel } from './city.model';
export class IcaRateModel {
  icaRateId: number = 0;
  cityId: number = 0;
  city: CityModel = new CityModel();
  conceptInvoicingId: number = 0;
  rate: number = 0;
  minimumBase: number = 0;
  code: string = "";
  saleAccount: string = "";
  saleDevolutionAccount: string = "";
  payAccountSelfWithholdingICA: string = "";
  devolutionAccountSelfWithholdingICA: string = "";
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}
